module.exports = __webpack_public_path__ + "static/img/dashboard-bg-2.9eff3ccc.jpg";